import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import VehicleAutoComplete from "@/components/AutoCompletes/VehicleAutoComplete";
import getVehicleResponse from "@/types/responses/getVehicle";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'UploadRequestVehicleAutoComplete',
  props: {
    modelValue: {},
    errorMessages: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const filterAction = (items: getVehicleResponse[]) => {
  return items.filter((item) => {
    return item.digital_tacograph;
  });
};

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VehicleAutoComplete), {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    itemName: "number_plate",
    "error-messages": __props.errorMessages,
    filterAction: filterAction,
    requestParams: { type: 'filter' }
  }, null, 8, ["modelValue", "error-messages"]))
}
}

})